import * as _ from 'lodash';
import PopupActions from '../../actions/PopupActions';
import GuestActions from '../../actions/GuestActions';

class GLSearchResult extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            uuid : uuid()
        };

        this.calcDimensions = this.calcDimensions.bind(this);
    }

    componentDidMount() {
        $(window).on('resize', this.calcDimensions);

        this.calcDimensions();

        this.setState({ isLoading: true }, () => {
            GuestActions.loadGuestAvatar(this.props.guest.Guest_id).then(
                image => {
                    this.setState({ isLoading: false, image, hasImage: !_.isEmpty(image) });
                }
            );
        });
    }

    componentWillUnmount() {
        $(window).off('resize', this.calcDimensions);
    }
    

    calcDimensions() {
        var width = $('#'+this.state.uuid).width();
        $('#'+this.state.uuid).css({
            'height' : width / 1.3
        });
    }

    render() {
        var guest = this.props.guest;

        return (
            <div
                className='gl-search__grid'
                onClick={() => { PopupActions.viewProfile(guest); }}
                key={guest.MJStateIDNo}
                id={this.state.uuid}>

                <div className='gl-search__grid--content'>
                    <div className='gl-search__grid--name'>
                       {guest.Name}
                    </div>
                    <div className='gl-search__grid--id-nr'>
                       {guest.MJStateIDNo}
                    </div>
                    {moment(guest.DOB).isValid() &&
                    <div className='gl-search__grid--date'>
                       {moment(guest.DOB).format('MM/DD/YYYY')}
                    </div>}

                    <div className='gl-search__grid--img'>
                        {this.state.isLoading ? <i className='fa fa-spinner fa-pulse' style={{ position: 'absolute', left:'50%', top: '50%' }} />
                        : this.state.hasImage ? <img src={this.state.image} /> : <img src='/assets/id_placeholder.png' />}
                    </div>

                </div>
            </div>
        );
    }
}

export default GLSearchResult;

/*



*/


// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/GLSearchResult.react.jsx